import React, { Dispatch, SetStateAction } from 'react';

import { StateLanguage } from '../../languages/config/StateLanguage';
import { evaluateLegendValidRequiredObjectMap } from '../../scripts/validate.legend.script';
import { expressions } from '../../libraries/regular.expressions.library';
import { suffixLegend } from '../../scripts/name.legend.script';
import { removeTooltip } from '../../tools/tooltip.tool';

import AppLegend from './Legend';
import { legendValidInvalidRestart } from '../../tools/legend.data.entry.tool';

export interface AppRequirementInputPriceProps {
  content: {value: any, index: number, sub_index: number},
  requirements: {list: boolean, value: {type: string, description: string, contents: any[]}[], valid: {type: boolean, description: boolean, content: boolean, contents: any[]}[]},
  setRequirements: Dispatch<SetStateAction<{list: boolean, value: {type: string, description: string, contents: any[]}[], valid: {type: boolean, description: boolean, content: boolean, contents: any[]}[]}>>
};

const AppRequirementInputPrice: React.FunctionComponent<AppRequirementInputPriceProps> = ({content, requirements, setRequirements}) => {
  const {lang} = StateLanguage()

  const handleChangePriceContentToRequirement = (event: React.ChangeEvent <HTMLFormElement | HTMLInputElement>) => {
    let tempRequirementsValue = requirements.value.map((temp_item, temp_index) => {
      if (content.index === temp_index) {
        temp_item.contents[content.sub_index].price_unit = event.target.value
      }
      return temp_item
    })

    setRequirements({...requirements, value: tempRequirementsValue})
  }

  const handleChangeTaxIncludeContentToRequirement = () => {
    let tempRequirementsValue = requirements.value.map((temp_item, temp_index) => {
      if (content.index === temp_index) {
        temp_item.contents[content.sub_index].tax_included = !content.value.tax_included
      }
      return temp_item
    })

    setRequirements({...requirements, value: tempRequirementsValue})
    removeTooltip()
  }

  const validatePriceContentToRequirement = () => {
    evaluateLegendValidRequiredObjectMap(expressions.currency, content.index, content.sub_index, 'price_unit', requirements, setRequirements, `legend-requirement-content-price-valid${suffixLegend(content.index, content.sub_index)}`, `legend-requirement-content-price-required${suffixLegend(content.index, content.sub_index)}`)

    if (content.value.rebate_type !== undefined && content.value.rebate_value !== undefined && content.value.rebate_quantity !== undefined) {
      if (expressions.currency.test(content.value.price_unit) && Number(content.value.price_unit) < 0) {
        let tempRequirementsValue = requirements.value.map((temp_item, temp_index) => {
          if (content.index === temp_index) {
            temp_item.contents[content.sub_index].rebate_type = 'none'
            temp_item.contents[content.sub_index].rebate_value = ''
            temp_item.contents[content.sub_index].rebate_quantity = ''
          }
          return temp_item
        })
        let tempRequirementsValid = requirements.valid.map((temp_item, temp_index) => {
          if (content.index === temp_index) {
            temp_item.contents[content.sub_index].rebate_value = true
            temp_item.contents[content.sub_index].rebate_quantity = true
          }
          return temp_item
        })

        setRequirements({...requirements, value: tempRequirementsValue, valid: tempRequirementsValid})
        legendValidInvalidRestart(`legend-requirement-content-rebate-valid${suffixLegend(content.index, content.sub_index)}`)
        legendValidInvalidRestart(`legend-requirement-content-rebate-required${suffixLegend(content.index, content.sub_index)}`)
      }
    }
  }

  return (
    <>
      <div className="position-relative">
        <input className="form-control form-control-solid ps-2 pe-20" type="text" autoComplete="off" name="price" value={content.value.price_unit} onChange={handleChangePriceContentToRequirement} onKeyUp={validatePriceContentToRequirement} onBlur={validatePriceContentToRequirement} />
        <button className="btn btn-bg-secondary btn-flex flex-center position-absolute translate-middle-y top-50 end-0 h-25px w-55px me-2" type="button" onClick={handleChangeTaxIncludeContentToRequirement}>
          <span className="btn-label text-primary text-uppercase fw-bolder fs-7" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" data-bs-original-title={content.value.tax_included ? lang.labels.thisOptionIncludeTaxPrice : lang.labels.thisOptionNotIncludeTaxPrice}>
            {content.value.tax_included ? lang.labels.net : lang.labels.gross}
          </span>
        </button>
      </div>
      <AppLegend attribute={{check: requirements.valid[content.index].contents[content.sub_index].price_unit, name: "requirement-content-price", index: content.index, sub_index: content.sub_index}} container={{valid: true, required: true, identical: false, exists: false}}></AppLegend>
    </>
  )
}

export default AppRequirementInputPrice;
